import { Mutex } from 'async-mutex';
import { getOnboardingUrl, getSetupCompleteUrl } from '../chrome/routing';
import {
  getTab,
  updateTab,
  getCurrentTab,
  createTab,
} from '../chrome/tabManager';

/**
 * Redirects a tab to a new URL.
 *
 * @param tabId - The ID of the tab to redirect
 * @param url - The final URL to redirect to
 * @returns Updated tab if redirect was successful,
 * undefined if is already in the same URL,
 * or undefined if the tab does not exist or is already in the same URL.
 */
const redirectMutex = new Mutex();
export const redirectToURL = (
  tabId: number,
  url: string
): Promise<chrome.tabs.Tab | undefined> =>
  redirectMutex.runExclusive(() => {
    return getTab(tabId)
      .then(tab => {
        if (!tab) {
          return Promise.reject(new Error('Tab does not exist!'));
        }
        // It should not be redirected if the redirect for that URL is already in progress,
        // or if the current URL already matches the new destination.
        if (tab.pendingUrl === url || tab.url === url) {
          return Promise.resolve(undefined);
        }

        return updateTab(tabId, { url: url });
      })
      .catch(error => {
        console.warn(error);
        return undefined;
      });
  });

export const redirectToSetupCompleteScreen =
  (): Promise<chrome.tabs.Tab | void> =>
    getCurrentTab()
      .then(tab =>
        tab?.id !== undefined
          ? redirectToURL(tab.id, getSetupCompleteUrl())
          : Promise.reject(new Error('Could not get current tab!'))
      )
      .catch(error => {
        console.warn(error);
      });

export const openOnboardingScreen = (): Promise<chrome.tabs.Tab> =>
  createTab({ url: getOnboardingUrl() });
